export class CProgress extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  static get observedAttributes() {
    return ["value", "segments", "variant"];
  }

  attributeChangedCallback() {
    this.render();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    const value = parseInt(this.getAttribute("value") || "0", 10);
    const variant = this.getAttribute("variant") || "simple";
    const color = this.getAttribute('color') || '';

    const segments = this.getAttribute("segments");
    const segmentData = segments ? JSON.parse(segments) : [];

    const styles = `
      :host {
        display: block;
        width: 100%;
      }
      .bar {
        height: 12px;
        border-radius: 50px;
        background: var(--black-16);
        position: relative;
        overflow: hidden;
      }
      .fill {
        height: 100%;
        background: ${color ? color : 'var(--tempora-primary)'};
        width: ${value}%;
        display: flex;
        align-items: center;
        transition: width 0.3s ease;
        position: relative;
      }
      .inline-label {
        color: white;
        font-size: 10px;
        position: absolute;
        top: 0;
        left: 50%;
      }
      .multi {
        display: flex;
        height: 100%;
      }
      .multi-segment {
        height: 100%;
      }
    `;

    let content = "";

    if (variant === "multicolor") {
      const total = segmentData.reduce((sum, seg) => sum + seg.value, 0);
      content = `
        <div class="bar">
          <div class="multi">
            ${segmentData
              .map(
                (seg) => `
                <div class="multi-segment" style="width:${(seg.value / total) * 100}%; background:${seg.color}"></div>
              `
              )
              .join("")}
          </div>
        </div>
      `;
    } else if (variant === "inline") {
      content = `
        <div class="bar">
          <div class="fill">
            <div class="inline-label">${value}%</div>
          </div>
        </div>
      `;
    } else {
      content = `
        <div class="bar">
          <div class="fill"></div>
        </div>
      `;
    }

    this.shadowRoot.innerHTML = `<style>${styles}</style>${content}`;
  }
}

customElements.define("c-progress", CProgress);